"use client";

import { trackEvent } from "@/lib/analytics";
import type { AnchorHTMLAttributes } from "react";

type TrackedLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  event: string;
  eventProps?: Record<string, unknown>;
};

/** Anchor that fires a PostHog event on click. */
export default function TrackedLink({
  event,
  eventProps,
  onClick,
  children,
  ...rest
}: TrackedLinkProps) {
  return (
    <a
      {...rest}
      onClick={(e) => {
        trackEvent(event, eventProps);
        onClick?.(e);
      }}
    >
      {children}
    </a>
  );
}
